module.exports = __webpack_public_path__ + "img/9788936485405.288c820d.jpg";